import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#D1D2D0",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "m2.726 6.976-.05.302a4.308 4.308 0 0 0 .162 2.07l.09.267a5.44 5.44 0 0 0 1.313 2.127l1.176 1.175 3.527 2.886a1.667 1.667 0 0 0 2.111 0l3.528-2.886 1.175-1.175a5.44 5.44 0 0 0 1.315-2.127l.088-.266a4.309 4.309 0 0 0 .163-2.07l-.05-.303a3.978 3.978 0 0 0-5.971-2.758l-1.062.637a.47.47 0 0 1-.483 0l-1.061-.637a3.978 3.978 0 0 0-5.97 2.758Z"
    }, null, -1)
  ])))
}
export default { render: render }